// Kept as an empty slice — some Berry template code still references
// `state.chat`; without this the whole store initializer silently no-ops
// and React fails to mount with no visible error.
const initialState = {};
export default function chat(state = initialState) {
  return state;
}
